<template>
  <div v-if="dialogVisible">
    <div class="code_search_dialog">
      <div class="input_box">
        <el-input
          :placeholder="$t('lang.搜索')"
          prefix-icon="el-icon-search"
          v-model="searchInput"
          @input="onChangeSearch"
        >
        </el-input>
      </div>
      <div class="code_list">
        <div
          v-for="item in codeList"
          :key="item.id"
          class="code_item"
          @click="onClickCode(item)"
        >
          <span>{{
            $i18n.locale == "zh-CN" ? item.nationNameZh : item.nationNameEn
          }}</span>
          <span class="value">{{ item.timeZoneCode }}</span>
        </div>
      </div>
    </div>
    <div class="mask" @click="hide"></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      dialogVisible: false,
      searchInput: "",
      codeList: [],
      defineList: [],
      localLanguage: "",
    };
  },
  created() {
    this.getAreaCode();
  },
  methods: {
    ...mapActions({
      countryConfigurationList: "ZD_CountryConfigurationList",
    }),
    onChangeSearch(e) {
      const searchValue = e.trim().toLowerCase();
      const filteredList = this.defineList.filter((item) => {
        return (
          item.nationNameZh.toLowerCase().includes(searchValue) ||
          item.nationNameEn.toLowerCase().includes(searchValue) ||
          item.timeZoneCode.toLowerCase().includes(searchValue)
        );
      });
      this.codeList = filteredList;
    },
    show() {
      this.dialogVisible = true;
      this.searchInput = "";
    },
    hide() {
      this.dialogVisible = false;
    },
    onClickCode(row) {
      this.hide();
      this.$emit("setAreaCode", row.timeZoneCode);
    },
    /**获取区号 */
    async getAreaCode() {
      let areaCode = this.$store.getters["areaCode/countriesAndRegions"];
      if (!this.isnull(areaCode)) {
        this.defineList = areaCode;
        this.codeList = this.docopy(areaCode);
        return;
      }
      let res = await this.countryConfigurationList({});
      if (res.success !== 1) return;
      this.defineList = res.listItem;
      this.codeList = this.docopy(this.defineList);
      this.$store.commit("areaCode/countriesAndRegions", res.listItem);
    },
  },
};
</script>

<style lang="less" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0;
  width: 100vw;
  height: 100vh;
}
.code_search_dialog {
  position: absolute;
  top: 110px;
  left: 0;
  z-index: 3;
  padding-top: 20px;
  background-color: white;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  width: 445px;
  .input_box {
    width: 100%;
    padding: 0 25px;
    box-sizing: border-box;
    margin-bottom: 16px;
  }
  /deep/ .el-input__inner {
    border: 1px solid #dcdfe6;
    padding-left: 32px;
    padding-bottom: 0;
  }
  .code_list {
    max-height: 200px;
    overflow-y: auto;
    .code_item {
      display: flex;
      justify-content: space-between;
      padding: 7px 25px;
      box-sizing: border-box;

      font-size: 14px;
      color: #666;
      cursor: pointer;
      .value {
        width: 94px;
        text-align: left;
      }
      &:hover {
        background-color: #edf5ff;
      }
    }
  }
}
</style>